import Day from "./Day";
import styles from "./day.module.css";
import { useMeals, useMealsAction } from "../../../Context/MealsProvider";
import Swal from "sweetalert2";
const DayList = ({ days, setDays, allMealsHandler, catValue, changeHandlerNaghlie, vehValue, changeHandlerVehicle, isKhareji }) => {
  const meals = useMeals();
  const dispatch = useMealsAction();



  const allDay = ["حرکت", "اول", "دوم", "سوم", "چهارم", "پنجم", "ششم", "هفتم", "هشتم", "نهم", "دهم"];

  const deleteHandler = (dayNum, id) => {
    Swal.fire({
      title: "روز مد نظر حذف شود؟",
      text: " عملیات قابل برگشت نیست",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "بله!",
      cancelButtonText: "انصراف",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch({ type: "reset", id: id, dayNum: dayNum });

        const filterItem = days.filter((p) => {
          return p.id !== id;
        });

        setDays(filterItem);
        Swal.fire("روز مد نظر حذف شد", "", "success");
      }
    });
  };

  return (
    <div className={styles.container}>
      {days.map((day, index) => {
        return <Day day={day} name={`روز ${allDay[index]}`} index={index} deleteHandler={() => deleteHandler(day.dayNum, day.id)} allMealsHandler={allMealsHandler} catValue={catValue} changeHandlerNaghlie={changeHandlerNaghlie} vehValue={vehValue} changeHandlerVehicle={changeHandlerVehicle} isKhareji={isKhareji} isLastDay={days.length == index + 1} />;
      })}
    </div>
  );
};

export default DayList;
